export default __webpack_public_path__ + "static/media/G0810-RemoveRemoveRemove.1710502860000.0f6731d7.jpg";